import { fieldIds } from 'src/util';
import { getTypeValidationKeys } from 'src/util/typeValidationMessages';
import * as y from 'yup';

const typeValidationKeys = getTypeValidationKeys();

export const FieldContract = y
  .object({
    fieldName: y.string().required(),
    value: y.mixed(),
    format: y.string(),
  })
  .strict();

export interface Field extends y.Asserts<typeof FieldContract> {}

// @ts-ignore
export const ValidationFieldContract = y.lazy(() =>
  y.object({
    [fieldIds.isPreApproval]: y.mixed().oneOf(['true', 'false']),
    [fieldIds.refinancingCurrentProperty]: y
      .mixed()
      .oneOf(['true', 'false'])
      .when('$loan', ([loan]) => {
        if (loan?.property?.loanPurposeType?.includes('Refinance')) {
          return y.string().required();
        }
        return y.string().optional();
      }),
    [fieldIds.hasRealtor]: y
      .string()
      .when(fieldIds.isPreApproval, ([isPreApproval]) => {
        if (isPreApproval === 'true') {
          return y.string().required();
        }
        return y.string().optional();
      }),
    [fieldIds.needsRealtor]: y
      .string()
      .when(
        [fieldIds.isPreApproval, fieldIds.hasRealtor],
        ([isPreApproval, hasRealtor]) => {
          if (isPreApproval === 'true') {
            return y.string().required();
          }
          return y.string().optional();
        },
      ),
    [fieldIds.hasOwnershipInterest]: y.mixed().oneOf(['true', 'false']),
    // coborrower
    [fieldIds.sameAddressAsBorrower]: y.mixed().oneOf(['Y', 'N']),
    [fieldIds.hasCoborrowerEmployment]: y.mixed().oneOf(['true', 'false']),
    [fieldIds.hasCoborrowerOwnershipInterest]: y
      .mixed()
      .oneOf(['true', 'false']),
  }),
);

export const fieldValidationErrorMap = {
  _entityName: 'Field',
  loan: {
    refinancing: {
      [fieldIds.refinancingCurrentProperty]:
        typeValidationKeys.field.refinancingCurrentProperty,
    },
    'found-agent': {
      [fieldIds.hasRealtor]: typeValidationKeys.field.hasRealtor,
    },
    'needs-agent': {
      [fieldIds.needsRealtor]: typeValidationKeys.field.needsRealtor,
    },
  },
  'assets-liabilities': {
    information: {
      [fieldIds.hasOwnershipInterest]:
        typeValidationKeys.field.hasOwnershipInterest,
    },
  },
};

export const coborrowerFieldValidationErrorMap = {
  _entityName: 'Field',
  coborrower: {
    'shares-address-with-borrower': {
      [fieldIds.sameAddressAsBorrower]:
        typeValidationKeys.field.sameAddressAsBorrower,
    },
    'shares-mailing-address': {
      [fieldIds.sameMailingAddressAsBorrower]:
        typeValidationKeys.field.sameMailingAddressAsBorrower,
    },
  },
  'assets-liabilities': {
    'coborrower-information': {
      [fieldIds.hasCoborrowerOwnershipInterest]:
        typeValidationKeys.field.hasCoborrowerOwnershipInterest,
    },
  },
};
